import { useEffect } from 'react'
import { Auth, Hub } from 'aws-amplify'
import { getAuthenticatedUser } from '../../Helpers'
import { useUserContext } from '../../hooks/useUser'
import { useNavigate } from 'react-router-dom'

const LoginSaml = () => {
  const { user, setUser } = useUserContext()
  const navigate = useNavigate()

  useEffect(() => {
    const handleUserData = async userData => {
      if (userData && !userData?.attributes['custom:entity']) {
        userData.attributes['custom:entity'] =
          userData.signInUserSession.idToken.payload['custom:entity']
        userData.attributes['custom:dashboard'] =
          userData.signInUserSession.idToken.payload['custom:dashboard']
      }

      if (userData) {
        const userEcom = await getAuthenticatedUser()
        setUser({ ...userData, ...userEcom })
        if (!userEcom) {
          navigate('/error')
        } else {
          navigate('/portals')
        }
      } else {
        navigate('/login')
      }

      Hub.listen('auth', ({ payload: { event } }) => {
        switch (event) {
          case 'signIn':
          case 'cognitoHostedUI':
            getUser().then(handleUserData)
            break
          case 'signOut':
            setUser({})
            break
          case 'signIn_failure':
          case 'cognitoHostedUI_failure':
            break
          default:
            break
        }
      })
    }

    getUser().then(handleUserData)
  }, [navigate, setUser, user])

  const getUser = async () => {
    return Auth.currentAuthenticatedUser({ bypassCache: true })
      .then(userData => userData)
      .catch(() => {
        Auth.federatedSignIn()
      })
  }

  return null
}

export default LoginSaml
